import {reportServices} from "../../service/reportService";
import {groupBy1Constants} from "../constants/groupBy1Constants";
import {alertActions} from "./alertActions";
import {campaignServices} from "../../service/campaignService";
import {trafficSourceServices} from "../../service/trafficSourceService";
import {integrationService} from "../../service/integrationService";
import {
    allowToGenerateHash, generateMD5HashHex, GetSelectedGroupByPlaceholderFromTrafficSource,
} from "../../components/reporting-table/ReactDataGridUtils";
import ExportCSV from "../../components/export/ExportCSV";
import {v4 as uuidv4} from 'uuid';
import {IsNumber} from "../../helpers/common";
import {LEVEL_1} from "./groupBy3Action";

export const groupBy1Action = {
    getDetailsReport,
    setSelectedName,
    updateOrderBy,
    updateSortBy,
    updateSortColumns,
    rerender,
    setSelectedRows,
    updateGroupBy,
    updateStatus,
    updateBid,
    updateBudget,
    getIntegrationData,
    findTrafficSourceAndIntegrationByTrafficSourceId,
    resetIntegration,
    resetTrafficSource,
    reset,
    expandRow,
    updateTreeViewData
};

function getDetailsReport(params, infinityScroll = false) {
    return (dispatch, getState) => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
        dispatch(alertActions.error(""));

        let integration = getState().groupBy1.integration;
        let trafficSource = getState().groupBy1.trafficSource;
        let column = getState().column.data;
        let groupBy = getState().groupBy1.groupBy?.groupBy;
        let groupByPlaceholder = GetSelectedGroupByPlaceholderFromTrafficSource(groupBy, trafficSource);

        // get details report
        reportServices.getDetailsReport(params)
            .then(async (result) => {

                // CSV export
                if (params?.export === "csv") {
                    ExportCSV({fileName: "details_report_" + params?.from + "_to_" + params?.to, data: result});
                    dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    return false;
                }

                // Add hashed custom1-10 values if column hash is not hidden.
                if (allowToGenerateHash(groupBy, column?.detailsReport)) {
                    for (const item of result?.records) {
                        item.hash = generateMD5HashHex(item?.name);
                    }
                }

                // Add UUID
                for (const item of result?.records) {
                    item.uuid = uuidv4(); // Add UUID for rows
                    item.type = LEVEL_1; // Add data level
                    item.isTreeView = !!params?.isTreeView;
                    item.expanded = false;
                }

                // Add Pushground integration check.
                if (integration?.networkType === "pushground") {
                    for (const item of result?.records) {
                        let pushgroundId = item?.name;
                        if (pushgroundId !== "" && pushgroundId.match(/^\d+$/) !== null) {
                            // find Pushground campaign if group by placeholder is {campaign_id}
                            if (groupByPlaceholder === "{campaign_id}") {
                                let pResult = await integrationService.findPushgroundCampaign(integration?.id, pushgroundId);
                                if (pResult?.id > 0) {
                                    item.status = pResult?.active;
                                    item.bid = pResult?.bid;
                                }
                            }
                        }
                    }
                }

                // Add PropellerAds integration check.
                if (integration?.networkType === "propeller-ads") {
                    let campaignIds = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (campaignIds === "") {
                                campaignIds += item?.name;
                            } else {
                                campaignIds += "," + item?.name;
                            }
                        }
                    }

                    // find PropellerAds campaigns if group by placeholder is {campaignid}
                    if (campaignIds !== "" && groupByPlaceholder === "{campaignid}") {
                        let pResult = await integrationService.findPropellerAdsCampaigns({
                            integrationId: integration?.id, campaignIds: campaignIds
                        });

                        for (const item of result?.records) {
                            for (const pCampaign of pResult) {
                                if (parseInt(pCampaign?.id) === parseInt(item?.name)) {
                                    item.status = pCampaign?.active;
                                    item.bid = pCampaign?.bid;
                                    item.rateModel = pCampaign?.rateModel;
                                }
                            }
                        }
                    }
                }

                // Add ExoClick integration check.
                if (integration?.networkType === "exoclick") {
                    let campaignIds = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (campaignIds === "") {
                                campaignIds += item?.name;
                            } else {
                                campaignIds += "," + item?.name;
                            }
                        }
                    }

                    // find ExoClick campaigns if group by placeholder is {campaign_id}
                    if (campaignIds !== "" && groupByPlaceholder === "{campaign_id}") {
                        let pResult = await integrationService.findExoClickCampaigns({
                            integrationId: integration?.id, campaignIds: campaignIds
                        });

                        for (const item of result?.records) {
                            for (const pCampaign of pResult) {
                                if (parseInt(pCampaign?.id) === parseInt(item?.name)) {
                                    item.status = pCampaign?.active;
                                    item.bid = pCampaign?.bid;
                                    item.rateModel = pCampaign?.rateModel;
                                }
                            }
                        }
                    }
                }

                // Add Mondiad integration check.
                if (integration?.networkType === "mondiad") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // find Mondiad campaigns if group by placeholder is [campaignid]
                    if (ids !== "" && groupByPlaceholder === "[campaignid]") {
                        try {
                            let pResult = await integrationService.findMondiadCampaigns({
                                integrationId: integration?.id, campaignIds: ids
                            });
                            for (const item of result?.records) {
                                for (const pCampaign of pResult) {
                                    if (parseInt(pCampaign?.id) === parseInt(item?.name)) {
                                        item.status = pCampaign?.active;
                                        item.bid = pCampaign?.bid;
                                        item.rateModel = pCampaign?.rateModel;
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }
                    // find Mondiad creatives if group by placeholder is [creativeid]
                    if (ids !== "" && groupByPlaceholder === "[creativeid]") {
                        try {
                            let intResult = await integrationService.findMondiadCreatives(
                                {integrationId: integration?.id, ids: ids}
                            );
                            for (const item of result?.records) {
                                for (const creative of intResult?.creatives) {
                                    if (parseInt(creative?.id) === parseInt(item?.name)) {
                                        item.status = creative?.active;
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }
                }

                // Add Google Ads integration check.
                if (integration?.networkType === "google") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // find Google Ads campaigns if group by placeholder is {campaignid}
                    if (ids !== "" && groupByPlaceholder === "{campaignid}") {
                        try {
                            let iResult = await integrationService.findGoogleAdsCampaigns({
                                integrationId: integration?.id, campaignIds: ids
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (parseInt(i?.id) === parseInt(item?.name)) {
                                        item.trafficSourceName = i?.name;
                                        if (i?.status === "ENABLED" || i?.status === "PAUSED") {
                                            item.status = i?.active;
                                        }
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }

                    // find Google Ads ad groups if group by placeholder is {adgroupid}
                    if (ids !== "" && groupByPlaceholder === "{adgroupid}") {
                        try {
                            let iResult = await integrationService.findGoogleAdsAdGroups({
                                integrationId: integration?.id, adGroupIds: ids
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (parseInt(i?.id) === parseInt(item?.name)) {
                                        item.trafficSourceName = i?.name;
                                        if (i?.status === "ENABLED" || i?.status === "PAUSED") {
                                            item.status = i?.active;
                                        }
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }

                    // find Google ads if group by placeholder is {creative}
                    if (ids !== "" && groupByPlaceholder === "{creative}") {
                        try {
                            let iResult = await integrationService.findGoogleAdsAdGroupAds({
                                integrationId: integration?.id, adIds: ids
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (parseInt(i?.id) === parseInt(item?.name)) {
                                        item.trafficSourceName = i?.name;
                                        item.trafficSourceAdGroupId = i?.adGroupId;
                                        if (i?.status === "ENABLED" || i?.status === "PAUSED") {
                                            item.status = i?.active;
                                        }
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }
                }

                // Add Microsoft Ads integration check.
                if (integration?.networkType === "microsoft") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // find Microsoft Ads campaigns if group by placeholder is {CampaignId}
                    if (ids !== "" && groupByPlaceholder === "{CampaignId}") {
                        try {
                            let iResult = await integrationService.findMicrosoftAdsCampaigns({
                                integrationId: integration?.id, campaignIds: ids
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (parseInt(i?.id) === parseInt(item?.name)) {
                                        item.trafficSourceName = i?.name;
                                        if (i?.status === "Active" || i?.status === "Paused") {
                                            item.status = i?.active;
                                        }
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }
                }

                // Add Facebook Ads integration check.
                if (integration?.networkType === "facebook") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // find Facebook Ads campaign, ad set and ad titles.
                    if (ids !== "" && ["{{campaign.id}}", "{{adset.id}}", "{{ad.id}}"].indexOf(groupByPlaceholder) !== -1) {

                        let level = "campaign";
                        if (groupByPlaceholder === "{{adset.id}}") {
                            level = "adset";
                        }
                        if (groupByPlaceholder === "{{ad.id}}") {
                            level = "ad";
                        }

                        try {
                            let iResult = await integrationService.findFacebookMetricsAndOtherFields({
                                integrationId: integration?.id,
                                level: level,
                                ids: ids,
                                dateStart: params?.from,
                                dateStop: params?.to
                            });
                            for (const item of result?.records) {
                                if (iResult?.insights?.length > 0) {
                                    for (const i of iResult?.insights) {
                                        if (i?.campaignId === item?.name) {
                                            item.trafficSourceName = i?.campaignName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            break;
                                        } else if (i?.adSetId === item?.name) {
                                            item.trafficSourceName = i?.adSetName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            break;
                                        } else if (i?.adId === item?.name) {
                                            item.trafficSourceName = i?.adName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            break;
                                        }
                                    }
                                }
                                if (iResult?.campaigns?.length > 0) {
                                    for (const c of iResult?.campaigns) {
                                        if (c?.id === item?.name) {
                                            item.trafficSourceName = c?.name;
                                            item.status = c?.status;
                                            item.fbDailyBudget = c?.dailyBudget;
                                            item.deliveryStatus = c?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                                if (iResult?.adSets?.length > 0) {
                                    for (const adSet of iResult?.adSets) {
                                        if (adSet?.id === item?.name) {
                                            item.trafficSourceName = adSet?.name;
                                            item.status = adSet?.status;
                                            item.fbDailyBudget = adSet?.dailyBudget;
                                            item.deliveryStatus = adSet?.deliveryStatus;
                                            if (adSet?.bidStrategy === "LOWEST_COST_WITH_BID_CAP" || adSet?.bidStrategy === "COST_CAP") {
                                                item.bid = adSet?.bidAmount;
                                                item.rateModel = "Bid";
                                            }
                                            if (adSet?.bidStrategy === "" && adSet?.bidAmount > 0) {
                                                item.bid = adSet?.bidAmount;
                                                item.rateModel = "Bid";
                                            }
                                            break;
                                        }
                                    }
                                }
                                if (iResult?.ads?.length > 0) {
                                    for (const ad of iResult?.ads) {
                                        if (ad?.id === item?.name) {
                                            item.trafficSourceName = ad?.name;
                                            item.status = ad?.status;
                                            item.fbDailyBudget = ad?.dailyBudget;
                                            item.deliveryStatus = ad?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            if (e?.response?.data?.error) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            } else {
                                dispatch(alertActions.error("Unable to load Facebook metrics data."));
                            }
                        }
                    }
                }

                // Add Taboola Ads integration check.
                if (integration?.networkType === "taboola") {
                    // find Taboola campaigns if group by placeholder is {campaign_id}
                    if (groupByPlaceholder === "{campaign_id}") {
                        try {
                            let iResult = await integrationService.findTaboolaCampaigns({
                                integrationId: integration?.id
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (parseInt(i?.id) === parseInt(item?.name)) {
                                        item.trafficSourceName = i?.name;
                                        item.status = i?.active;
                                        item.deliveryStatus = i?.status;
                                        item.fbDailyBudget = i?.dailyBudget;
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }
                }

                // Add MGID Ads integration check.
                if (integration?.networkType === "mgid") {
                    // find MGID campaigns if group by placeholder is {campaign_id}
                    if (groupByPlaceholder === "{campaign_id}") {
                        let ids = "";
                        for (const item of result?.records) {
                            if (item?.name?.match(/^\d+$/) !== null) {
                                if (ids === "") {
                                    ids += item?.name;
                                } else {
                                    ids += "," + item?.name;
                                }
                            }
                        }

                        if (ids !== "") {
                            try {
                                let iResult = await integrationService.findMgidCampaigns({
                                    integrationId: integration?.id,
                                    campaignIds: ids
                                });
                                for (const item of result?.records) {
                                    for (const i of iResult) {
                                        if (parseInt(i?.id) === parseInt(item?.name)) {
                                            item.trafficSourceName = i?.name;
                                            item.status = i?.active;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            }
                        }
                    }
                    if (groupByPlaceholder === "{teaser_id}") {
                        let ids = "";
                        for (const item of result?.records) {
                            if (item?.name?.match(/^\d+$/) !== null) {
                                if (ids === "") {
                                    ids += item?.name;
                                } else {
                                    ids += "," + item?.name;
                                }
                            }
                        }

                        if (ids !== "") {
                            try {
                                let iResult = await integrationService.findMgidAds({
                                    integrationId: integration?.id,
                                    adIds: ids
                                });
                                for (const item of result?.records) {
                                    for (const i of iResult) {
                                        if (parseInt(i?.id) === parseInt(item?.name)) {
                                            item.status = i?.active;
                                            item.deliveryStatus = i?.deliveryStatus
                                            let bidNum = i?.bid / 100;
                                            item.bid = bidNum.toFixed(4);
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            }
                        }
                    }
                }

                // Add Outbrain Ads integration check.
                if (integration?.networkType === "outbrain") {
                    // find Outbrain campaigns if group by placeholder is {{campaign_id}}
                    if (groupByPlaceholder === "{{campaign_id}}") {

                        // Filter campaign IDs that match 34 lowercase alphanumeric chars AND start with "00"
                        const ids = result?.records
                            ?.filter(item => /^[a-z0-9]{34}$/.test(item?.name) && item.name.startsWith("00"))
                            .map(item => item.name)
                            .join(",") || "";

                        if (ids !== "") {
                            try {
                                let iResult = await integrationService.findOutbrainCampaigns({
                                    integrationId: integration?.id,
                                    campaignIds: ids
                                });
                                for (const item of result?.records) {
                                    for (const i of iResult) {
                                        if (i?.id === item?.name) {
                                            item.trafficSourceName = i?.name;
                                            item.status = i?.status;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            item.bid = i?.bid;
                                            item.bidRate = i?.bidRate;
                                            item.budgetId = i?.budget?.id;
                                            item.fbDailyBudget = i?.budget?.amount;
                                            item.fbAccountCurrency = i?.budget?.currency;
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            }
                        }
                    }
                }

                // Add Facebook Ads integration check.
                if (integration?.networkType === "tiktok") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // Find TikTok campaign, adgroup and ad titles.
                    if (ids !== "" && ["__CAMPAIGN_ID__", "__AID__", "__CID__"].indexOf(groupByPlaceholder) !== -1) {

                        let level = "campaign";
                        if (groupByPlaceholder === "__AID__") {
                            level = "adgroup";
                        } else if (groupByPlaceholder === "__CID__") {
                            level = "ad";
                        }

                        try {
                            let iResult = await integrationService.findTikTokMetricsAndOtherFields({
                                integrationId: integration?.id,
                                level: level,
                                ids: ids,
                                dateStart: params?.from,
                                dateStop: params?.to
                            });
                            for (const item of result?.records) {
                                if (iResult?.insights?.length > 0) {
                                    for (const i of iResult?.insights) {
                                        if (parseInt(i?.campaignId) === parseInt(item?.name)) {
                                            item.trafficSourceName = i?.campaignName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            break;
                                        } else if (parseInt(i?.adGroupId) === parseInt(item?.name)) {
                                            item.trafficSourceName = i?.adGroupName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            break;
                                        } else if (parseInt(i?.adId) === parseInt(item?.name)) {
                                            item.trafficSourceName = i?.adName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            break;
                                        }
                                    }
                                }
                                if (iResult?.campaigns?.length > 0) {
                                    for (const c of iResult?.campaigns) {
                                        if (parseInt(c?.id) === parseInt(item?.name)) {
                                            item.trafficSourceName = c?.name;
                                            item.status = c?.status;
                                            if (c?.dailyBudget > 0) {
                                                item.fbDailyBudget = c?.dailyBudget;
                                            }
                                            item.deliveryStatus = c?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                                if (iResult?.adGroups?.length > 0) {
                                    for (const adGroup of iResult?.adGroups) {
                                        if (parseInt(adGroup?.id) === parseInt(item?.name)) {
                                            item.trafficSourceName = adGroup?.name;
                                            item.status = adGroup?.status;
                                            if (adGroup?.dailyBudget > 0) {
                                                item.fbDailyBudget = adGroup?.dailyBudget;
                                            }
                                            item.deliveryStatus = adGroup?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                                if (iResult?.ads?.length > 0) {
                                    for (const ad of iResult?.ads) {
                                        if (parseInt(ad?.id) === parseInt(item?.name)) {
                                            item.trafficSourceName = ad?.name;
                                            item.status = ad?.status;
                                            item.fbDailyBudget = ad?.dailyBudget;
                                            item.deliveryStatus = ad?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            if (e?.response?.data?.error) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            } else {
                                dispatch(alertActions.error("Unable to load TikTok metrics data."));
                            }
                        }
                    }
                }

                // Add Outbrain Ads integration check.
                if (integration?.networkType === "revcontent") {
                    // find RevContent campaigns if group by placeholder is {boost_id}
                    if (groupByPlaceholder === "{boost_id}") {
                        let ids = "";
                        for (const item of result?.records) {
                            if (item?.name?.match(/^\d+$/) !== null) {
                                if (ids === "") {
                                    ids += item?.name;
                                } else {
                                    ids += "," + item?.name;
                                }
                            }
                        }

                        if (ids !== "") {
                            try {
                                let iResult = await integrationService.findRevContentCampaigns({
                                    integrationId: integration?.id,
                                    campaignIds: ids,
                                    dateStart: params?.from,
                                    dateStop: params?.to
                                });
                                for (const item of result?.records) {
                                    for (const i of iResult) {
                                        if (parseInt(i?.id) === parseInt(item?.name)) {
                                            item.trafficSourceName = i?.name;
                                            item.status = i?.active;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            item.bid = i?.bid;
                                            item.rateModel = i?.bidRate;
                                            item.fbDailyBudget = i?.dailyBudget;
                                            item.fbAccountCurrency = i?.currency;
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            }
                        }
                    }
                }

                // Add Outbrain DSP Ads integration check.
                if (integration?.networkType === "outbrain_dsp") {
                    // find Outbrain DSP campaigns if group by placeholder is {campaignid}
                    if (groupByPlaceholder === "{campaignid}") {
                        let ids = "";
                        for (const item of result?.records) {
                            if (item?.name?.match(/^\d+$/) !== null) {
                                if (ids === "") {
                                    ids += item?.name;
                                } else {
                                    ids += "," + item?.name;
                                }
                            }
                        }

                        if (ids !== "") {
                            try {
                                let iResult = await integrationService.findOutbrainDSPCampaigns({
                                    integrationId: integration?.id,
                                    campaignIds: ids
                                });
                                for (const item of result?.records) {
                                    for (const i of iResult) {
                                        if (i?.id === item?.name) {
                                            item.trafficSourceName = i?.name;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            }
                        }
                    }

                    // find Outbrain DSP Ad Group if group by placeholder is {adgroupid}
                    if (groupByPlaceholder === "{adgroupid}") {
                        let ids = "";
                        for (const item of result?.records) {
                            if (item?.name?.match(/^\d+$/) !== null) {
                                if (ids === "") {
                                    ids += item?.name;
                                } else {
                                    ids += "," + item?.name;
                                }
                            }
                        }

                        if (ids !== "") {
                            try {
                                let iResult = await integrationService.findOutbrainDSPAdGroups({
                                    integrationId: integration?.id,
                                    adGroupIds: ids
                                });
                                for (const item of result?.records) {
                                    for (const i of iResult) {
                                        if (i?.id === item?.name) {
                                            item.trafficSourceName = i?.name;
                                            item.status = i?.status;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            item.bid = i?.bid;
                                            item.rateModel = i?.bidRate;
                                            item.fbDailyBudget = i?.dailyBudgetAmount;
                                            item.fbAccountCurrency = i?.dailyBudgetCurrency;
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            }
                        }
                    }
                }

                // Add Newsbreak integration check
                if (integration?.networkType === "newsbreak") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    if (groupByPlaceholder === "__CAMPAIGN_ID__" && ids !== "") {
                        try {
                            let iResult = await integrationService.findNewsBreakCampaigns({
                                integrationId: integration?.id
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (i?.id === item?.name) {
                                        item.trafficSourceName = i?.name;
                                        item.status = i?.status;
                                        item.deliveryStatus = i?.deliveryStatus;
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }

                    if (groupByPlaceholder === "__FLIGHT_ID__" && ids !== "") {
                        try {
                            let iResult = await integrationService.findNewsBreakAdSets({
                                integrationId: integration?.id
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (i?.id === item?.name) {
                                        item.trafficSourceName = i?.name;
                                        item.status = i?.status;
                                        item.deliveryStatus = i?.deliveryStatus;
                                        item.fbDailyBudget = i?.dailyBudgetAmount;
                                        item.fbAccountCurrency = i?.dailyBudgetCurrency;

                                        if (i?.rateModel === "TARGET_CPA") {
                                            item.bid = i?.bid;
                                            item.rateModel = "CPA";
                                        }

                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }

                    if (groupByPlaceholder === "__CREATIVE_ID__" && ids !== "") {
                        try {
                            let iResult = await integrationService.findNewsBreakAds({
                                integrationId: integration?.id
                            });
                            for (const item of result?.records) {
                                for (const i of iResult) {
                                    if (i?.id === item?.name) {
                                        item.trafficSourceName = i?.name;
                                        item.status = i?.status;
                                        item.deliveryStatus = i?.deliveryStatus;
                                        break;
                                    }
                                }
                            }
                        } catch (e) {
                            dispatch(alertActions.error(e?.response?.data?.error));
                        }
                    }
                }

                // Add SmartNews integration check
                if (integration?.networkType === "smartnews") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // Find SmartNews campaign, adgroup and ad titles.
                    if (ids !== "" && ["{campaign_id}", "{ad_group_id}", "{ad_id}"].indexOf(groupByPlaceholder) !== -1) {

                        let level = "campaigns";
                        if (groupByPlaceholder === "{ad_group_id}") {
                            level = "ad_groups";
                        } else if (groupByPlaceholder === "{ad_id}") {
                            level = "ads";
                        }

                        try {
                            let iResult = await integrationService.findSmartNewsMetricsAndAdditionalColumns({
                                integrationId: integration?.id,
                                level: level,
                                ids: ids,
                                dateStart: params?.from,
                                dateStop: params?.to
                            });
                            for (const item of result?.records) {
                                if (iResult?.insights?.length > 0) {
                                    for (const i of iResult?.insights) {
                                        if (i?.campaignId === item?.name) {
                                            item.trafficSourceName = i?.campaignName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);

                                            item.status = i?.status;
                                            if (i?.dailyBudget > 0) {
                                                item.fbDailyBudget = i?.dailyBudget;
                                            }
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        } else if (i?.adGroupId === item?.name) {
                                            item.trafficSourceName = i?.adGroupName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);

                                            item.status = i?.status;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        } else if (i?.adId === item?.name) {
                                            item.trafficSourceName = i?.adName;
                                            item.fbCpm = i?.cpm;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbLinkCpc = i?.linkCpc;
                                            item.fbCtr = i?.linkCtr;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);

                                            item.status = i?.status;
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            if (e?.response?.data?.error) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            } else {
                                dispatch(alertActions.error("Unable to load SmartNews metrics and additional columns data."));
                            }
                        }
                    }
                }

                // Add MediaGo integration check
                if (integration?.networkType === "mediago") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // Find MediaGo campaign titles.
                    // eslint-disable-next-line no-template-curly-in-string
                    if (ids !== "" && ["${CAMPAIGN_ID}"].indexOf(groupByPlaceholder) !== -1) {
                        let level = "campaign";
                        try {
                            let iResult = await integrationService.findMediaGoMetricsAndAdditionalColumns({
                                integrationId: integration?.id,
                                level: level,
                                ids: ids,
                                dateStart: params?.from,
                                dateStop: params?.to
                            });
                            for (const item of result?.records) {
                                if (iResult?.insights?.length > 0) {
                                    for (const i of iResult?.insights) {
                                        if (i?.campaignId === item?.name) {
                                            item.trafficSourceName = i?.campaignName;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            item.bid = i?.linkCpc;

                                            item.status = i?.status;
                                            if (i?.dailyBudget > 0) {
                                                item.fbDailyBudget = i?.dailyBudget;
                                            }
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            if (e?.response?.data?.error) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            } else {
                                dispatch(alertActions.error("Unable to load MediaGo metrics and additional columns data."));
                            }
                        }
                    }
                }

                // Add MediaGo integration check
                if (integration?.networkType === "popin") {
                    let ids = "";
                    for (const item of result?.records) {
                        if (item?.name?.match(/^\d+$/) !== null) {
                            if (ids === "") {
                                ids += item?.name;
                            } else {
                                ids += "," + item?.name;
                            }
                        }
                    }

                    // Find Popin campaign titles.
                    // eslint-disable-next-line no-template-curly-in-string
                    if (ids !== "" && ["${CAMPAIGN_ID}"].indexOf(groupByPlaceholder) !== -1) {
                        let level = "campaign";
                        try {
                            let iResult = await integrationService.findPopinMetricsAndAdditionalColumns({
                                integrationId: integration?.id,
                                level: level,
                                ids: ids,
                                //dateStart: "2025-08-20 00:00:00",
                                //dateStop: "2025-08-20 23:59:59"
                                dateStart: params?.from,
                                dateStop: params?.to
                            });
                            for (const item of result?.records) {
                                if (iResult?.insights?.length > 0) {
                                    for (const i of iResult?.insights) {
                                        if (i?.campaignId === item?.name) {
                                            item.trafficSourceName = i?.campaignName;
                                            item.fbImpressions = i?.impressions;
                                            item.fbLinkClicks = i?.linkClicks;
                                            item.fbAccountCurrency = i?.accountCurrency;
                                            item.fbEpc = parseFloat(item?.revenue) / parseInt(i?.linkClicks);
                                            item.bid = i?.linkCpc;

                                            item.status = i?.status;
                                            if (i?.dailyBudget > 0) {
                                                item.fbDailyBudget = i?.dailyBudget;
                                            }
                                            item.deliveryStatus = i?.deliveryStatus;
                                            break;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            if (e?.response?.data?.error) {
                                dispatch(alertActions.error(e?.response?.data?.error));
                            } else {
                                dispatch(alertActions.error("Unable to load Popin metrics and additional columns data."));
                            }
                        }
                    }
                }

                if (infinityScroll) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_INFINITY_SCROLL, result});
                } else {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result});
                }
            }).catch((error) => {
                dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, error});
                if (error?.response?.data?.error) {
                    dispatch(alertActions.error(error?.response?.data?.error));
                } else {
                    dispatch(alertActions.error("Invalid request. Please change your Group By values."));
                }
            }
        );
    };
}

function setSelectedName(name) {
    return (dispatch) => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_SET_SELECTED_NAME, name});
    };
}

function updateOrderBy(orderBy) {
    return (dispatch) => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_UPDATE_ORDER_BY, orderBy});
    };
}

function updateSortBy(sortBy) {
    return (dispatch) => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_UPDATE_SORT_BY, sortBy});
    };
}

function updateSortColumns(sortColumns) {
    return (dispatch) => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_UPDATE_SORT_COLUMNS, sortColumns});
    };
}

function rerender() {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_RERENDER});
    };
}

function setSelectedRows(selectedUUIDs, selectedRows) {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_SET_SELECTED_ROW, payload: {selectedUUIDs, selectedRows}});
    };
}

function expandRow({clickedRowUUID, parentRowUUID, level, expandStatus}) {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_EXPAND_ROW, payload: {clickedRowUUID, parentRowUUID, level, expandStatus}});
    };
}

function updateGroupBy(groupBy) {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_UPDATE_GROUP_BY, groupBy});
    };
}

function updateStatus({status, name}) {
    return (dispatch, getState) => {

        let result = getState().groupBy1.data;
        let integration = getState().groupBy1.integration;
        let trafficSource = getState().groupBy1.trafficSource;
        let groupBy = getState().groupBy1.groupBy?.groupBy;
        let groupByPlaceholder = GetSelectedGroupByPlaceholderFromTrafficSource(groupBy, trafficSource);

        if (integration !== null) {
            if (integration?.networkType === "pushground") {
                if (groupByPlaceholder === "{campaign_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePushgroundCampaignStatus(status, integration?.id, name).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "propeller-ads") {
                if (groupByPlaceholder === "{campaignid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePropellerAdsCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "exoclick") {
                if (groupByPlaceholder === "{campaign_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateExoClickCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mondiad") {
                if (groupByPlaceholder === "[campaignid]") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMondiadCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
                if (groupByPlaceholder === "[creativeid]") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMondiadCreativeStatus({
                        status: status, integrationId: integration?.id, creativeId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "google") {
                if (groupByPlaceholder === "{campaignid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateGoogleAdsCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
                if (groupByPlaceholder === "{adgroupid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateGoogleAdsAdGroupStatus({
                        status: status, integrationId: integration?.id, adGroupId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
                if (groupByPlaceholder === "{creative}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));

                    let adGroupId = 0;
                    for (let i of result?.records) {
                        if (i?.trafficSourceAdGroupId > 0) {
                            adGroupId = i?.trafficSourceAdGroupId;
                            break;
                        }
                    }

                    integrationService.updateGoogleAdsAdGroupAdStatus({
                        status: status, integrationId: integration?.id, adGroupId, adId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "microsoft") {
                if (groupByPlaceholder === "{CampaignId}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMicrosoftAdsCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "taboola") {
                if (groupByPlaceholder === "{campaign_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateTaboolaCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "facebook") {
                let fbPlaceholders = ["{{campaign.id}}", "{{adset.id}}", "{{ad.id}}"]
                if (fbPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateFacebookStatus({
                        status: status, integrationId: integration?.id, id: name
                    }).then((response) => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                const isActive = response?.success === true && status;
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: isActive ? "Active" : "Paused",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mgid") {
                if (groupByPlaceholder === "{campaign_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMgidCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then((response) => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: response?.deliveryStatus,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
                if (groupByPlaceholder === "{teaser_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMgidAdStatus({
                        status: status, integrationId: integration?.id, adId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "outbrain") {
                if (groupByPlaceholder === "{{campaign_id}}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateOutbrainCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "tiktok") {
                let fbPlaceholders = ["__CAMPAIGN_ID__", "__AID__", "__CID__"]

                let level = "campaign";
                if (groupByPlaceholder === "__AID__") {
                    level = "adgroup";
                } else if (groupByPlaceholder === "__CID__") {
                    level = "ad"
                }

                if (fbPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateTikTokStatus({
                        status: status, level: level, integrationId: integration?.id, id: name
                    }).then((response) => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                const isActive = response?.success === true && status;
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: isActive ? "Active" : "Inactive",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "revcontent") {
                if (groupByPlaceholder === "{boost_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateRevContentCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then((response) => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: response?.active ? "Active" : "Disabled",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "outbrain_dsp") {
                if (groupByPlaceholder === "{adgroupid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateOutbrainDSPAdGroupStatus({
                        status: status, integrationId: integration?.id, adGroupId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "newsbreak") {
                if (groupByPlaceholder === "__CAMPAIGN_ID__") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateNewsBreakCampaignStatus({
                        status: status, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: status ? "Active" : "Inactive",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }

                if (groupByPlaceholder === "__FLIGHT_ID__") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateNewsBreakAdSetStatus({
                        status: status, integrationId: integration?.id, adSetId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: status ? "Active" : "Inactive",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }

                if (groupByPlaceholder === "__CREATIVE_ID__") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateNewsBreakAdStatus({
                        status: status, integrationId: integration?.id, adId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: status ? "Active" : "Inactive",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "smartnews") {
                let snPlaceholders = ["{campaign_id}", "{ad_group_id}", "{ad_id}"]

                let level = "campaigns";
                if (groupByPlaceholder === "{ad_group_id}") {
                    level = "ad_groups";
                } else if (groupByPlaceholder === "{ad_id}") {
                    level = "ads"
                }

                if (snPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateSmartNewsStatus({
                        status: status, level: level, integrationId: integration?.id, id: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: status ? "Active" : "Paused",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mediago") {
                // eslint-disable-next-line no-template-curly-in-string
                let snPlaceholders = ["${CAMPAIGN_ID}"]
                let level = "campaign";
                if (snPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMediaGoStatus({
                        status: status, level: level, integrationId: integration?.id, id: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: status ? "Active" : "Paused",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "popin") {
                // eslint-disable-next-line no-template-curly-in-string
                let snPlaceholders = ["${CAMPAIGN_ID}"]
                let level = "campaign";
                if (snPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePopinStatus({
                        status: status, level: level, integrationId: integration?.id, id: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map((record) => {
                            if (record?.name === name) {
                                return {
                                    ...record,
                                    status: status,
                                    deliveryStatus: status ? "Active" : "Paused",
                                };
                            }
                            return record;
                        });
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch(alertActions.success("Updated successfully"));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }
        }
    };
}

function updateBid({bid, name}) {
    return (dispatch, getState) => {

        let result = getState().groupBy1.data;
        let integration = getState().groupBy1.integration;
        let trafficSource = getState().groupBy1.trafficSource;
        let groupBy = getState().groupBy1.groupBy?.groupBy;
        let groupByPlaceholder = GetSelectedGroupByPlaceholderFromTrafficSource(groupBy, trafficSource);

        if (integration !== null) {
            if (integration?.networkType === "pushground") {
                if (groupByPlaceholder === "{campaign_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePushgroundCampaignBid(bid, integration?.id, name).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "propeller-ads") {
                if (groupByPlaceholder === "{campaignid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePropellerAdsCampaignBid({
                        bid: bid, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "exoclick") {
                if (groupByPlaceholder === "{campaign_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateExoClickCampaignBid({
                        bid: bid, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mondiad") {
                if (groupByPlaceholder === "[campaignid]") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMondiadCampaignBid({
                        bid: bid, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mgid") {
                if (groupByPlaceholder === "{teaser_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMgidAdBid({
                        bid: bid, integrationId: integration?.id, adId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "outbrain") {
                if (groupByPlaceholder === "{{campaign_id}}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateOutbrainCampaignBid({
                        bid: bid, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "facebook") {
                if (bid > 0 && ["{{adset.id}}"].indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateFacebookAdSetBid({
                        bid: bid, integrationId: integration?.id, id: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "revcontent") {
                if (groupByPlaceholder === "{boost_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateRevContentCampaignBid({
                        bid: bid, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "outbrain_dsp") {
                if (groupByPlaceholder === "{adgroupid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateOutbrainDSPAdGroupBid({
                        bid: bid, integrationId: integration?.id, adGroupId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "newsbreak") {
                if (groupByPlaceholder === "__FLIGHT_ID__") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateNewsBreakAdSetBid({
                        bid: bid, integrationId: integration?.id, adSetId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mediago") {
                // eslint-disable-next-line no-template-curly-in-string
                if (groupByPlaceholder === "${CAMPAIGN_ID}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMediaGoCampaignBidding({
                        bid: bid,
                        integrationId: integration?.id,
                        campaignId: name,
                        level: "campaign",
                        reason: "bid"
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "popin") {
                // eslint-disable-next-line no-template-curly-in-string
                if (groupByPlaceholder === "${CAMPAIGN_ID}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePopinCampaignBidding({
                        bid: bid,
                        integrationId: integration?.id,
                        campaignId: name,
                        level: "campaign",
                        reason: "bid"
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {...record, bid: bid}
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }
        }
    };
}

function updateBudget({amount, name, budgetId}) {
    return (dispatch, getState) => {

        let result = getState().groupBy1.data;
        let integration = getState().groupBy1.integration;
        let trafficSource = getState().groupBy1.trafficSource;
        let groupBy = getState().groupBy1.groupBy?.groupBy;
        let groupByPlaceholder = GetSelectedGroupByPlaceholderFromTrafficSource(groupBy, trafficSource);

        if (integration !== null) {

            if (integration?.networkType === "facebook") {
                if (amount > 0 && ["{{campaign.id}}", "{{adset.id}}", "{{ad.id}}"].indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateFacebookDailyBudget({
                        dailyBudget: amount, integrationId: integration?.id, id: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: parseFloat(amount)
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "tiktok") {
                let ttPlaceholders = ["__CAMPAIGN_ID__", "__AID__", "__CID__"]
                let level = "campaign";
                if (groupByPlaceholder === "__AID__") {
                    level = "adgroup";
                }

                if (amount > 0 && ttPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateTikTokDailyBudget({
                        dailyBudget: amount, level: level, integrationId: integration?.id, id: name
                    }).then((response) => {
                        if (!response?.success) {
                            dispatch(alertActions.error(response?.message));
                            dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                        } else {
                            const updatedRecords = result?.records?.map(record =>
                                record?.name === name
                                    ? {
                                        ...record,
                                        fbDailyBudget: amount
                                    }
                                    : record
                            );
                            const updatedResult = {...result, records: updatedRecords};

                            dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                            dispatch(alertActions.success("Updated successfully"));
                        }
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                    }).finally(() => {
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "outbrain") {
                if (amount > 0 && groupByPlaceholder === "{{campaign_id}}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateOutbrainCampaignBudget({
                        amount: amount, integrationId: integration?.id, budgetId: budgetId
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "taboola") {
                if (groupByPlaceholder === "{campaign_id}" && IsNumber(name)) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateTaboolaCampaignDailyBudget({
                        amount: amount, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "revcontent") {
                if (amount > 0 && groupByPlaceholder === "{boost_id}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateRevContentCampaignBudget({
                        budget: amount, integrationId: integration?.id, campaignId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "outbrain_dsp") {
                if (amount > 0 && groupByPlaceholder === "{adgroupid}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateOutbrainDSPAdGroupDailyBudget({
                        amount: amount, integrationId: integration?.id, adGroupId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "newsbreak") {
                if (amount > 0 && groupByPlaceholder === "__FLIGHT_ID__") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateNewsBreakAdSetDailyBudget({
                        amount: amount, integrationId: integration?.id, adSetId: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "smartnews") {
                let smPlaceholders = ["{campaign_id}"]
                if (amount > 0 && smPlaceholders.indexOf(groupByPlaceholder) !== -1) {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateSmartNewsDailyBudget({
                        dailyBudget: amount, integrationId: integration?.id, id: name
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                    }).finally(() => {
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "mediago") {
                // eslint-disable-next-line no-template-curly-in-string
                if (amount > 0 && groupByPlaceholder === "${CAMPAIGN_ID}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updateMediaGoCampaignBidding({
                        dailyBudget: amount,
                        integrationId: integration?.id,
                        campaignId: name,
                        level: "campaign",
                        reason: "dailyBudget"
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }

            if (integration?.networkType === "popin") {
                // eslint-disable-next-line no-template-curly-in-string
                if (amount > 0 && groupByPlaceholder === "${CAMPAIGN_ID}") {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
                    dispatch(alertActions.error(""));
                    integrationService.updatePopinCampaignBidding({
                        dailyBudget: amount,
                        integrationId: integration?.id,
                        campaignId: name,
                        level: "campaign",
                        reason: "dailyBudget"
                    }).then(() => {
                        const updatedRecords = result?.records?.map(record =>
                            record?.name === name
                                ? {
                                    ...record,
                                    fbDailyBudget: amount
                                }
                                : record
                        );
                        const updatedResult = {...result, records: updatedRecords};

                        dispatch({type: groupBy1Constants.GROUP_BY_1_GET_DATA, result: updatedResult});
                        dispatch(alertActions.success("Updated successfully"));
                    }).catch((e) => {
                        dispatch(alertActions.error(e?.response?.data?.error));
                        dispatch({type: groupBy1Constants.GROUP_BY_1_STOP_LOADING_SPINNER});
                    });
                }
            }
        }
    };
}

function getIntegrationData(campaignId) {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_LOADING_SPINNER});
        dispatch(alertActions.error(""));
        // find campaign by campaign ID.
        campaignServices.find(campaignId).then((campaign) => {
            // find traffic source by trafficID with integration info.
            trafficSourceServices.find(campaign?.trafficId).then((trafficSource) => {
                dispatch({type: groupBy1Constants.GROUP_BY_1_SET_TRAFFIC_SOURCE_DATA, trafficSource});
                // find integration
                integrationService.findIntegration(trafficSource?.integrationId).then((integration) => {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_SET_INTEGRATION_DATA, integration});
                }).catch((e) => {
                    dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, e});
                    dispatch(alertActions.error(e?.response?.data?.error));
                });
            }).catch((e) => {
                dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, e});
                dispatch(alertActions.error(e?.response?.data?.error));
            });
        }).catch((e) => {
            dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, e});
            dispatch(alertActions.error(e?.response?.data?.error));
        });
    };
}

function findTrafficSourceAndIntegrationByTrafficSourceId() {
    return async (dispatch, getState) => {

        const filterTrafficSources = getState().campaign.filterTrafficSources;
        const isCurrent = () => getState().campaign.filterTrafficSources === filterTrafficSources;

        if (filterTrafficSources?.length === 1 && filterTrafficSources[0]?.value > 0) {
            await trafficSourceServices.find(filterTrafficSources[0]?.value).then(async (trafficSource) => {
                if (!isCurrent()) return;
                dispatch({type: groupBy1Constants.GROUP_BY_1_SET_TRAFFIC_SOURCE_DATA, trafficSource});
                // find integration
                if (trafficSource?.integrationId > 0) {
                    await integrationService.findIntegration(trafficSource?.integrationId).then((integration) => {
                        if (isCurrent()) dispatch({type: groupBy1Constants.GROUP_BY_1_SET_INTEGRATION_DATA, integration});
                    }).catch((e) => {
                        if (!isCurrent()) return;
                        dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, e});
                        dispatch(alertActions.error(e?.response?.data?.error));
                    });
                }
            }).catch((e) => {
                if (!isCurrent()) return;
                dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, e});
                dispatch(alertActions.error(e?.response?.data?.error));
            });
        }
    };
}

function resetIntegration() {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_SET_INTEGRATION_DATA, integration: null});
    };
}

function resetTrafficSource() {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_SET_TRAFFIC_SOURCE_DATA, trafficSource: null});
    };
}

function reset() {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_RESET});
    };
}

function updateTreeViewData({groupByNumber}) {
    return dispatch => {
        dispatch({type: groupBy1Constants.GROUP_BY_1_UPDATE_TREE_VIEW_DATA, payload: {groupByNumber}});
    };
}
